import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { SideMenuSubItem } from '../../../../components/navigation/SideMenu'
import { useNavigation } from '../../../../utils/contexts/NavigationContext'

const SubItem = ({ path, permission, hide, ...props }) => {
  const valid = useSessionPermission(permission)
  const navigate = useNavigation()
  if (!!hide) return false
  if (!!permission && !valid) return false

  return <SideMenuSubItem onClick={() => path && navigate(path)} to={path} {...props} />
}

export default SubItem
